import React, {Component} from 'react';
import {connect} from 'react-redux'

import bindAll from 'lodash.bindall';
import VersionUpdateComponent from '../components/versionUpdate/versionUpdate.jsx';

class VersionUpdateContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [

        ]);
        this.state = {
            inputVlue: "",

        }
    }



    render() {

        return (
            <VersionUpdateComponent

            />
        )
    }


}

VersionUpdateContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VersionUpdateContainer);
